
import { Vue, prop, Options } from "vue-class-component";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { ProductData } from "@/domain/entities/Product";
import debounce from "lodash/debounce";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  discount = prop<string>({
    type: String,
    default: "",
  });
  error = prop<any>({
    required: true,
  });
  isDisabled = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  emits: ["update:modelValue", "update:error"],
  watch: {
    modelValue: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.productDiscount = JSON.parse(JSON.stringify(newVal));
        }
      },
      deep: true,
      immediate: true,
    },
    productDiscount: {
      handler(newVal) {
        const isDiscountNotError = newVal.every((currentValue: any) => Number(currentValue.discount || 0) <= 30)
        if (!isDiscountNotError) {
          this.error.discount = true;
          this.$emit("update:error", { ...this.error, discount: true });
        } else {
          this.error.discount = false;
          this.$emit("update:error", { ...this.error, discount: false });
        }
      },
      deep: true,
      immediate: true,
    }
  },
})
class DiscountProduct extends Vue.with(Props) {
  productDiscount = [
    {
      discount: "",
      product: "",
    },
  ];

  get disabledAddProductDiscount() {
    return (
      this.productDiscount.some((item: any) => !item.product?.name) ||
      !!this.productDiscount.find((item: any) => item.product?.name === "SEMUA")
    );
  }

  formatFloat(value: string) {
    return value
      .replace(/[^0-9,.]+/g, "")
      .replace(/\.|\.,|,,|,\./g, ",")
      .replace(/,(\d+),/g, ",$1");
  }

  updateValue() {
    this.$emit("update:modelValue", this.productDiscount);
  }

  updateDiscount() {
    this.updateValue();
  }

  addProductDiscount() {
    if (!this.disabledAddProductDiscount) {
      this.productDiscount.push({
        discount: "",
        product: "",
      });
    }
  }

  deleteProductDiscount(idx: number) {
    this.productDiscount.splice(idx, 1);
  }

  isLoadingProduct = true;
  listProduct: ProductData[] = [];

  fetchProduct = debounce(async (search: string) => {
    this.isLoadingProduct = true;
    this.listProduct = [];
    const responseProduct = await ProductController.getProductList({
      page: 1,
      limit: 99,
      search: search,
      status: "active",
      productCode: "",
    });
    this.listProduct = responseProduct.data;
    if (this.productDiscount.length === 1) {
      this.listProduct.unshift(new ProductData({ id: 0, name: "SEMUA" }));
    }
    this.isLoadingProduct = false;
  }, 250);

  onBlur() {
    this.isLoadingProduct = true;
  }

  getFilteredProducts(currentIdx: number) {
    const selectedIds = this.productDiscount
      .map((item: any, idx: number) => (idx !== currentIdx && item.product?.id ? item.product.id : null))
      .filter((id: number | null) => id !== null);

    return this.listProduct.filter((product: ProductData) => !selectedIds.includes(product.id));
  }
}
export default DiscountProduct;
